import { createRef } from "react"
import type { VariableSizeList } from "react-window"

import type { ReferencesContextValue } from "./ReferencesContextValue"

export const defaultReferencesContextValue: ReferencesContextValue = {
  containerElementRef: createRef<HTMLDivElement>(),
  listElementRef: createRef<VariableSizeList>(),
}
